import {Backing} from "@/backing/interfaces/backing";

const BackingService = () => {
    return {
        /**
         * Get the billing label for a backing.
         */
        billingExtended: (backing?: Backing) => {
            if (backing?.first_year_billing_act?.code) {
                if (backing.next_years_billing_act?.code) {
                    return backing.first_year_billing_act.code
                        + ' la première année d\'accompagnement '
                        + ' et ' + backing.next_years_billing_act.code
                        + ' les suivantes.';
                }

                return backing.first_year_billing_act.code;
            }

            return '';
        },

        /**
         * Get the act code for a backing.
         */
        actCode: (backing?: Backing) => {
            if (backing?.first_year_billing_act?.code) {
                return backing.first_year_billing_act.code;
            }

            if (backing?.next_years_billing_act?.code) {
                return backing.next_years_billing_act.code;
            }

            return '';
        }
    };
};

export default BackingService();
